export default __webpack_public_path__ + "static/media/Adventurous.10e76e0c.svg";